module.exports = __webpack_public_path__ + "img/zcl.69550867.svg";